
angular.module('qkr').filter('roleName', (gettextCatalog) => function(input) {
    	let output = '';
    	
    	switch (input) {
    		case 'ROLE_MERCHANT_ADMIN':
    			output = gettextCatalog.getString('Merchant Manager');
    			break;
			case 'ROLE_MERCHANT_USER':
				output = gettextCatalog.getString('Outlet Manager');
				break;
    		case 'ROLE_DEPARTMENT_MANAGER':
    			output = gettextCatalog.getString('Department Manager');
    			break;
			case 'ROLE_REPORT_MANAGER':
				output = gettextCatalog.getString('Report Manager');
				break;
    		case 'ROLE_FULFILMENT_USER':
    			output = gettextCatalog.getString('Fulfillment App User');
    			break;
    		default:
    			output = input.replace('ROLE_', ' ').replace('_', ' ').toLowerCase();
    			break;
    	}
        
        return output;
    });



// WEBPACK FOOTER //
// ./src/filters/rolename.js